module.exports = __webpack_public_path__ + "static/media/timer-black-button.70116986.png";